package com.nonopn.skywatcher.common.app.pages.administrators

import com.nonopn.skywatcher.common.app.api.impl.ThunderDetectionUser
import com.nonopn.skywatcher.design.widgets.abslists.AbstractListModelState
import com.nonopn.skywatcher.design.widgets.abslists.ListModelStateHolder

data class AdministratorsModelState(
    val isLoading: Boolean,
    val canInvite: Boolean,
    override val modelState: ListModelStateHolder<ThunderDetectionUser> = ListModelStateHolder()
) : AbstractListModelState<ThunderDetectionUser>
